import * as exMount from './mount';

// ----------------------------------------------------------------------------

function init(): void {
    // Get elements (select)
    const elements = document.querySelectorAll<HTMLSelectElement>('select[data-select]');

    // Foreach Elements
    for (const element of elements) {
        if (!element.closest('.select-custom')) {
            exMount.mount(element);
        }
    }
}

// ----------------------------------------------------------------------------

// Create event (ready)
document.addEventListener('DOMContentLoaded', init);

// ----------------------------------------------------------------------------

export default init;
